import { Component, NgZone, ChangeDetectorRef, Input, EventEmitter, ViewEncapsulation } from '@angular/core';
import { AssignmentRecord } from "@playbook/data-models/records/assignment-record";
import { PSTFieldNames } from "@common/data-models/fields/pst-field-names";
import { TopicRecord } from '../../data-models/records/topic-record';
import { PlaybookService } from '../../services/playbook-service';
import { Staff } from '@src/suite/common/data-models/service/staff';

@Component({
    selector: 'assignments-overlay',
    templateUrl: './assignments-overlay.html',
    styleUrls: ['./assignments-overlay.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        'class': 'st-assignments-overlay'
    }
})
export class AssignmentsOverlay {
    @Input() public data: TopicRecord;
    @Input() public editable: boolean;
    @Input() public isPanelOpen: boolean;
    @Input() public onObjectOpen: EventEmitter<any> = new EventEmitter();
    pstFieldNames = PSTFieldNames;

    public get assignmentOwnerProperty(): string {
        return PSTFieldNames.PSTAssignmentOwner;
    }

    get allUsers(): Staff[] {
        return Object.values(this.playbookService.globalTablesService.Staff);
    }

    constructor(
        public ngZone: NgZone,
        public changeDetectorRef: ChangeDetectorRef,
        public playbookService: PlaybookService
    ) {}

    // public getItemInitials(item: any) {
    //     if(!item.owner) {
    //         return this.allUsers.find(option => (option.UserID.toLowerCase().includes(item?.owner?.toLowerCase())))?.Initials;
    //     }
    // }

    public getUserID(rec: AssignmentRecord): string {
        return this.playbookService.appService.getUserID(rec); 
    }

    public getUserName(rec: AssignmentRecord): string {
        return this.playbookService.appService.getUserName(rec);
    }
}